import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import HiredLogo from "@/components/brand/HiredLogo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(form.email, form.password);
      toast.success("Welcome back.");
      nav(u.onboarding_complete ? "/dashboard" : "/onboarding");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian text-ivory flex">
      <div className="hidden md:block flex-1 border-r border-line p-14">
        <Link to="/"><HiredLogo size={22} /></Link>
        <div className="mt-24 max-w-lg">
          <div className="brand-eyebrow mb-4">WELCOME BACK</div>
          <div className="brand-headline text-7xl">The work<br /><span className="text-purple italic">didn&apos;t stop.</span></div>
          <div className="text-steel mt-8 text-lg">Your employees kept working while you were away. See what got done.</div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <form onSubmit={onSubmit} className="w-full max-w-md">
          <div className="brand-eyebrow mb-6">LOG IN</div>
          <h1 className="brand-headline text-5xl mb-10">Sign in.</h1>
          <div className="space-y-5">
            <div>
              <label htmlFor="email">Email</label>
              <input data-testid="login-email" id="email" type="email" autoComplete="email" required
                value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
            </div>
            <div>
              <label htmlFor="password">Password</label>
              <input data-testid="login-password" id="password" type="password" autoComplete="current-password" required
                value={form.password} onChange={e => setForm({...form, password: e.target.value})} />
            </div>
          </div>
          <button data-testid="login-submit-btn" type="submit" disabled={busy} className="btn-gold w-full justify-center mt-8">
            {busy ? "Signing in…" : (<>Sign in <ArrowRight size={16} /></>)}
          </button>
          <div className="mt-6 text-smoke text-sm">
            Don't have an account? <Link to="/signup" className="text-gold hover:underline">Get started</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
